module.exports = "query ($reference: ID!) {\n  Page(id: $reference) {\n    id\n    name\n  }\n}\n"